module.exports = __webpack_public_path__ + "static/media/rubrik.9f48a345.jpeg";